import { useTranslation } from "../../translations/LanguageContext";

export function Header() {
    const { language, switchLanguage, t } = useTranslation();

    return (
        <header>
            <nav className="nav-links">
                <img className="logo" alt={t("header.logoAlt")} src="/logo.png" />
                <a href="/" className={window.location.pathname === "/" ? "nav-link active" : "nav-link"}>{t("header.nav.home")}</a>
                <a href="/analyse" className={window.location.pathname === "/analyse" ? "nav-link active" : "nav-link"}>{t("header.nav.analyse")}</a>
                <a href="/compare" className={window.location.pathname === "/compare" ? "nav-link active" : "nav-link"}>{t("header.nav.compare")}</a>
                <a href="/features" className={window.location.pathname === "/features" ? "nav-link active" : "nav-link"}>{t("header.nav.features")}</a>
                <a href="/about" className={window.location.pathname === "/about" ? "nav-link active" : "nav-link"}>{t("header.nav.about")}</a>
            </nav>

            <div className="language-toggle">
                <div className={`toggle-pill ${language === "english" ? "english" : ""}`} />
                <button
                    className={`lang ${language === "welsh" ? "active" : ""}`}
                    onClick={() => switchLanguage("welsh")}
                >
                    CY
                </button>
                <button
                    className={`lang ${language === "english" ? "active" : ""}`}
                    onClick={() => switchLanguage("english")}
                >
                    EN
                </button>
            </div>
        </header>
    );
}
